import type { NextRouter } from 'next/router';

// Inlined from the removed Spark page-context module (AI-933).
const QUERY_NOTE_ID = 'noteId';
const ADD_NOTE_PARAM = 'addNote';

/**
 * Adds noteId to the current URL query so that useCurrentNote() can resolve the note.
 * Call when opening the note dialog with an existing note.
 */
export function addNoteIdToUrl(router: NextRouter, noteId: string): void {
  const query = { ...router.query, [QUERY_NOTE_ID]: noteId };
  void router.replace({ pathname: router.pathname, query }, undefined, { shallow: true });
}

/**
 * Removes noteId (and addNote) from the URL query. Call when closing the note dialog.
 */
export function removeNoteIdFromUrl(router: NextRouter): void {
  const { [QUERY_NOTE_ID]: _n, [ADD_NOTE_PARAM]: _a, ...rest } = router.query;
  const query = rest;
  void router.replace({ pathname: router.pathname, query }, undefined, { shallow: true });
}
